<template>
  <div class="container">
    <div class="inner-component">
      <slot />
    </div>
    <div
      class="description-container"
      v-bind:class="{ floating: showInfoIcon, double: double }"
      v-if="description"
    >
      <div v-if="showInfoIcon">
        <img src="@/assets/img/1x/0info_icon.png" alt="Ícono información" />
      </div>
      <div>
        <span class="description" v-safe-html="description" />
        <custom-link
          v-if="textMoreInfo"
          label="Más Informacion"
          @click.native="showModal = true"
        />
        <more-info
          :show="showModal"
          @close="showModal = false"
          :textModal="textMoreInfo"
          :titleModal="titleMoreInfo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomLink from "@/components/core/CustomLink";
import MoreInfo from "@/components/core/modals/MoreInfo";

export default {
  name: "FloatingTip",
  props: {
    description: [String, Boolean],
    showInfoIcon: Boolean,
    double: Boolean,
    textMoreInfo: String,
    titleMoreInfo: String
  },
  components: {
    CustomLink,
    MoreInfo
  },

  data() {
    return {
      showModal: false
    };
  }
};
</script>

<style scoped>
.inner-component >>> div {
  margin-bottom: 8px;
}
span.description {
  width: 100%;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666666;
  white-space: normal;
}

div.description-container {
  display: flex;
  padding-top: 5px;
}

div.description-container div {
  vertical-align: top;
}

div.description-container div > img {
  margin-right: 7px;
}

div.description-container div > span {
  display: block;
}

@media screen and (min-width: 600px) {
  .container {
    position: relative;
  }

  /* Si el tip tiene un ícono, se aplica el floating */
  div.description-container.floating {
    position: absolute;
    left: 100%;
    width: 80%; /* Fallback para los que no soportan vw */
    width: 35vw; /* Ancho del tooltip approx 35% del ancho del viewport */
    top: 0;
    padding-left: 36px;
  }

  div.description-container.floating.double {
    left: 205%;
    left: calc(200% + 36px);
  }
}
</style>
